
export interface EpiLink {
    name: string;
    title: string;
    target: string;
    url: string;
    isFile: boolean;
    subItems?: EpiLink[];
}

export interface EpiVideo {
    url: string;
}

export interface CrisisBannerData {
    dateFrom?: Date;
    dateTo?: Date;
    heading: string;
    text: string;
    linkUrl: string;
    isEmergency?: boolean;
    isGlobal?: boolean;
    bannerEnabled?: boolean;
}

export interface Breadcrumb {
    position?: number;
    name: string;
    displayName?: string;
    url: string;
    type?: string;
}

export interface PageModel<T> {
    viewModel: T;
}

export enum SiteIcons {
    HOUSE = 'House',
    CONTRACT = 'Contract',
    UMBRELLA = 'Umbrella',
    FAVORITE = 'favorite',
    INTEREST = 'interest',
    PURCHASE = 'kop-anmalan-big',
    SHOWING = 'showing',
    CONTACT = 'Contact',
    SUSTAINABILITY = 'Sustainability',
    EMPTY = '',
}

export enum GalleryType {
    OBJECT = 'object',
    STAGE = 'stage',
    AREA = 'area',
    BLOCK = 'block'
}
